<template>
  <div class="content">
    <LoadingOverlay :loading="Isloading" />
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h4 class="title User-title">Assigned Tasks</h4>
              <div class="ms-auto">
                <button
                  type="button"
                  title="Back"
                  class="btn btn-dark btn-sm ms-2"
                  @click="goBack"
                >
                  Back
                </button>
              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="col-md-12">
             
              <div class="table-responsive">
                <div v-if="loadingTasks" class="text-center">
                  <p>{{ loadingTasks }}</p>
                </div>
                <md-table
                  v-if="!loadingTasks"
                  v-model="tasks"
                  
                >
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    :class="{ 'expired-row': isRowExpired(item) }"
                  >
                  <md-table-cell md-label="Task ID">{{
                      item.TaskId
                    }}</md-table-cell>
                    <md-table-cell md-label="Title">{{
                      item.Title
                    }}</md-table-cell>
                 <md-table-cell md-label="Status">
                      
                      <span
                        v-if="item.TaskStatus === 1"
                        class="taskNotAssigned"
                      >
                        Not Assigned
                      </span>
                      <span
                        v-else-if="item.TaskStatus === 2"
                        class="taskAssigned"
                        >Assigned
                      </span>
                      <span
                        v-else-if="item.TaskStatus === 3"
                        class="taskInProcess"
                        >In Process
                      </span>
                      <span
                        v-else-if="item.TaskStatus === 4"
                        class="taskCompleted"
                        >Completed
                      </span>
                    </md-table-cell>
                    <md-table-cell md-label="Category">
                      <span>
                        {{ item.CategoryName }}
                      </span>
                    </md-table-cell>
                    <md-table-cell md-label="Priority">
                      
                      <span >
                        {{ item.PriorityName }}
                      </span>
                    </md-table-cell>
                    <md-table-cell md-label="Assign Date">{{
                      item.CreatedDate
                    }}</md-table-cell>
                    <md-table-cell md-label="Due Date">{{
                      formatDueDate(item.DueDate)
                    }}</md-table-cell>
                    <!-- <md-table-cell md-label="Is Completed">{{
                      item.IsCompleted ? "Yes" : "No"
                    }}</md-table-cell> -->
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import api, { setAuthToken } from "../apiConfig";
import { authMixin } from "./adminStore";
import Cookies from "js-cookie";
import { ErrorLog } from "../Common/APILog";
import LoadingOverlay from '../Common/blockoutpage.vue';
export default {
  mixins: [authMixin],
  props: {
    UserID: {
      type: Number,
      required: true,
    },
    FilterID: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.checkAuthorization();
  },
  name: "UserTask",
  components: {
    LoadingOverlay
  },
  data() {
    return {
      tasks: [],
      Isloading:false,
      newTask: {
        updateTaskId: 0,
        TaskID: 0,
        UserId: 0,
        selectedUsers: [],
        DueDate: null,
      },
      taskFilterDropdownOPtions: [
      { Id: 0, Name: "All Task" },
        { Id: 2, Name: "Assigned" },
        { Id: 4, Name: "Completed" },
        { Id: 3, Name: "In Process" },
      ],
      taskFormHeader: "",
      successAlertOnSubmit: "",
      editTaskMode: false,
      loadingTasks: "",
      btnTaskEnable: false,
      DropdownOptions: [],
      //filterId: 0,
      name:"User Assigned Tasks"
    };
  },
  computed: {
    
    isRowExpired() {
      return (item) => item.IsExpired === 1;
    },
  },
  mounted() {
    this.getTasks(this.UserID);

  },

  methods: {
    formatDueDate(originalDate, type = "show") {
      if (!originalDate) return ""; // Handle null or undefined dates

      const dateObject = new Date(originalDate);
      const day = dateObject.getDate().toString().padStart(2, "0");
      const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
      const year = dateObject.getFullYear();
      if (type == "show") {
        return `${day}/${month}/${year}`;
      } else {
        return `${year}-${month}-${day}`;
      }
    },
    handleGridFilterChange() {
      this.getTasks(this.UserID);
    },
    goBack() {
      // Go back to the previous page in the history
      this.$router.go(-1);
    },
    async getTasks(UserID) {
      this.tasks = [];
      this.Isloading=true;
      this.loadingTasks = "Loading...";
      try {
        const token =await Cookies.get("jwt");
        setAuthToken(token);
        // let userCookie = Cookies.get("admin");
        // userCookie = userCookie ? JSON.parse(userCookie) : null;
        const response = await api.get(
          `/api/admin/tasks/get-assigned-tasks/${parseInt(UserID)}?filterId=${this.FilterID}`
        );
        if (response.data) {
          this.tasks = response.data;
          console.log(this.tasks);
          var element = document.querySelector('.User-title');
          if(this.FilterID==2){
          element.textContent = "Assigned Task to "+this.tasks[0].FirstName +" "+ this.tasks[0].LastName; 
          }
          if(this.FilterID==4){
          element.textContent = "Completed Task by "+this.tasks[0].FirstName +" "+ this.tasks[0].LastName; 
          }
        } else {
          // Handle case where no tasks are found
        }
      } catch (error) {
        // Handle API error
        if (error.response && error.response.data) {
          if (error.response.status === 401) {
            handleAuthorization("/login")
          }
          else if (error.response.status === 500) {
            handleServerError("/login")
          }
          else {
            const jsonResponseString = JSON.stringify(error.response.data);
            try {
              const jsonObject = JSON.parse(jsonResponseString);
              // this.tableHeader = jsonObject.message || "Something went wrong.";
            } catch (parseError) {
              // this.tableHeader = parseError.message || "Something went wrong.";
            }
            ErrorLog(error.message, error.response.status, 562, error.stack, "AdminPanel/UserTasks/getTasks()");
          }
        }
        else {
          // this.tableHeader = "Something went wrong.";
        }
      } finally {
        this.Isloading=false;
        if (this.tasks.length > 0) {
          this.loadingTasks = "";
        } else {
          this.loadingTasks = "No tasks found.";
        }
      }
    },
  },
};
</script>

<style scoped>
/* Add Tailwind CSS classes here if needed */
.close-icon {
  cursor: pointer;
  float: right;
  font-size: 30px;
  margin-top: -10px;
}
.mb-3 {
  text-align: left;
}
.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1em;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.table th {
  background-color: #f2f2f2;
}

/* Additional styling for left and right padding */
.table th,
.table td {
  padding-left: 12px;
  padding-right: 12px;
}

.actionBtns {
  text-align: right !important;
}

.user-list {
  max-height: 120px; /* Set a maximum height for the user list */
  overflow-y: auto; /* Add a scrollbar when the content exceeds the height */
  border: 1px solid #ccc; /* Optional: Add a border for styling */
}

.user-item {
  margin-bottom: 8px; /* Optional: Add some spacing between user items */
}
.toprow{
  color: #fff;
    background: #0d6efd;
    height: 35px;
    font-weight: 500;
    font-size: 16px;
}
.expired-row {
  background-color: #f66868;
}
.gridFilter {
  margin-left: auto;
  height: 30px;
  width: 130px;
}


</style>
